// extracted by mini-css-extract-plugin
export default {"titlePage":"organization_titlePage__v3fWv"};